import { ApiException } from './Error';

import { getPollDetail } from '@sdk/managers/PollsManager';
import {
  checkPledgedUserByPoll,
  listPledgedPollsByUser,
  listPledgedUsersByPoll,
} from '@sdk/managers/PledgesManager';
import { getVotedPollInfo, listVotedUser } from '@sdk/managers/VotesManager';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { DEFAULT_USER_FIELDS, User } from './User';
import {
  Detail,
  Poll,
  PollOption,
  S3Object,
  PollStatus,
  VoteResult,
} from '@sdk/models';
import { getImageUrl } from './image';
import { isWithinInterval } from 'date-fns';
import { getIdeaById } from '@sdk/managers/IdeaManager';
import { PollComment } from '@sdk/API';

interface S3ObjectURL extends S3Object {
  url?: string;
}

interface FormattedPollOption extends PollOption {
  count?: number;
  detail?: Detail & { image?: S3ObjectURL };
}

export interface FormattedPoll extends Poll {
  options?: FormattedPollOption[];
  winOption?: FormattedPollOption;
  endDate: Date;
  startDate: Date;
  isVotePeriod: boolean;
  pledgePeriod1StartDate?: Date;
  pledgePeriod1EndDate?: Date;
  isPledgePeriod: boolean;
  voteCount: number;
  password?: string;
  image?: S3ObjectURL;
}

export interface PollDetail {
  poll: Poll & {
    password?: string;
    voteResults?: { items: VoteResult[] };

    division?: string;
    grc?: string;
    isPremium?: boolean;
  };
  subPolls?: [Poll & { voteResults?: { items: VoteResult[] } }];
}

export interface FormattedPollDetail {
  poll: FormattedPoll;
  subPolls?: FormattedPoll[];
}

export const formatIdeaData = async (
  idea: any
): Promise<any> => {
  const formattedIdea = idea

  formattedIdea.startDate = idea.startTime
    ? new Date(idea.startTime)
    : new Date();
    formattedIdea.endDate = idea.endTime 
    ? new Date(idea.endTime)
    : new Date();
  

  
  
  
  if (idea.image) {
    formattedIdea.image = {
      ...idea.image,
      url: await getImageUrl(idea.image),
    };
  }


  // formattedIdea.startDate = idea.startTime
  //   ? new Date(idea.startTime)
  //   : new Date();
  //   formattedIdea.endDate = idea.endTime ? new Date(idea.endTime) : new Date();
  

  
  
  
  // if (idea.image) {
  //   formattedIdea.image = {
  //     ...idea.image,
  //     url: await getImageUrl(idea.image),
  //   };
  // }

  // formattedIdea.pledges.items = formattedIdea.pledges.items
  //   ? ((await Promise.all(
  //     formattedIdea.pledges.items.map(async (opt: any) => {
  //         const formattedOpt = opt;

  //         if (formattedOpt.detail?.image) {
  //           formattedOpt.detail.image = {
  //             ...formattedOpt.detail.image,
  //             url: await getImageUrl(formattedOpt.detail.image),
  //           };
  //         }
  //         return formattedOpt;
  //       })
  //     )) as any)
  //   : [];

  // if (
  //   formattedPoll.voteResults &&
  //   ((formattedPoll.voteResults as any).items?.length || 0) > 0
  // ) {
  //   const optCountDict = {};

  //   (formattedPoll.voteResults as any).items.forEach(
  //     (voteResult: VoteResult, index: number) => {
  //       if (voteResult.count !== undefined) {
  //         ((formattedPoll.voteResults as any).items as any[])[index].count =
  //           Math.max(voteResult.count || 0, 0);
  //         // Sum
  //         if (formattedPoll.voteCount === undefined) {
  //           formattedPoll.voteCount = Math.max(voteResult.count || 0, 0);
  //         }

  //         // Set count in option
  //         const optId = voteResult.id?.split('.')?.[1];
  //         if (optId) optCountDict[optId] = Math.max(voteResult.count || 0, 0);
  //       }
  //     }
  //   );

  //   formattedPoll.options = formattedPoll.options?.map((opt) => {
  //     const count = Math.max(optCountDict[opt.id] || 0, 0);
  //     const newOpt = {
  //       ...opt,
  //       count,
  //     };
  //     return newOpt;
  //   });
  // }

  // if (formattedPoll.winOption?.id) {
  //   let winOption = formattedPoll.winOption;
  //   const optId = formattedPoll.winOption?.id?.split('.')?.[1];
  //   if (optId) {
  //     const winOpt = formattedPoll.options?.find((opt) => opt.id === optId);
  //     if (winOpt) {
  //       winOption = {
  //         ...winOpt,
  //         id: formattedPoll.winOption?.id,
  //       };
  //     }
  //   }
  //   formattedPoll.winOption = winOption;
  // }

  return {...formattedIdea,pledges:{
    items:formattedIdea?.pledges?.items?.reverse()
  }};
};

export const formatPollData = async (
  _poll: Poll & { voteResults?: { items: VoteResult[] } & {comments?:{items:PollComment[]}} }
): Promise<FormattedPoll> => {
  const formattedPoll = _poll as FormattedPoll;
  console.log(formattedPoll)
  formattedPoll.startDate = _poll.startTime
    ? new Date(_poll.startTime)
    : new Date();
  formattedPoll.endDate = _poll.endTime ? new Date(_poll.endTime) : new Date();
  formattedPoll.isVotePeriod =
    formattedPoll.startDate && formattedPoll.endDate
      ? isWithinInterval(new Date(), {
          start: formattedPoll.startDate,
          end: formattedPoll.endDate,
        })
      : false;

  formattedPoll.pledgePeriod1StartDate = _poll.pledgePeriod1StartTime
    ? new Date(_poll.pledgePeriod1StartTime)
    : undefined;
  formattedPoll.pledgePeriod1EndDate = _poll.pledgePeriod1EndTime
    ? new Date(_poll.pledgePeriod1EndTime)
    : undefined;

  formattedPoll.isPledgePeriod =
    formattedPoll.pledgePeriod1StartDate && formattedPoll.pledgePeriod1EndDate
      ? isWithinInterval(new Date(), {
          start: formattedPoll.pledgePeriod1StartDate,
          end: formattedPoll.pledgePeriod1EndDate,
        })
      : false;
  formattedPoll.voteCount =
    _poll.voteResults?.items.reduce((count, value) => {
      if (!value) {
        return count;
      }
      return count + Math.max(value.count || 0, 0);
    }, 0) || 0;
  if (_poll.image) {
    formattedPoll.image = {
      ..._poll.image,
      url: await getImageUrl(_poll.image),
    };
  }

  formattedPoll.options = formattedPoll.options
    ? ((await Promise.all(
        formattedPoll.options.map(async (opt: any) => {
          const formattedOpt = opt;

          if (formattedOpt.detail?.image) {
            formattedOpt.detail.image = {
              ...formattedOpt.detail.image,
              url: await getImageUrl(formattedOpt.detail.image),
            };
          }
          return formattedOpt;
        })
      )) as any)
    : [];

  if (
    formattedPoll.voteResults &&
    ((formattedPoll.voteResults as any).items?.length || 0) > 0
  ) {
    const optCountDict = {};

    (formattedPoll.voteResults as any).items.forEach(
      (voteResult: VoteResult, index: number) => {
        if (voteResult.count !== undefined) {
          ((formattedPoll.voteResults as any).items as any[])[index].count =
            Math.max(voteResult.count || 0, 0);
          // Sum
          if (formattedPoll.voteCount === undefined) {
            formattedPoll.voteCount = Math.max(voteResult.count || 0, 0);
          }

          // Set count in option
          const optId = voteResult.id?.split('.')?.[1];
          if (optId) optCountDict[optId] = Math.max(voteResult.count || 0, 0);
        }
      }
    );

    formattedPoll.options = formattedPoll.options?.map((opt) => {
      const count = Math.max(optCountDict[opt.id] || 0, 0);
      const newOpt = {
        ...opt,
        count,
      };
      return newOpt;
    });
  }

  if (formattedPoll.winOption?.id) {
    let winOption = formattedPoll.winOption;
    const optId = formattedPoll.winOption?.id?.split('.')?.[1];
    if (optId) {
      const winOpt = formattedPoll.options?.find((opt) => opt.id === optId);
      if (winOpt) {
        winOption = {
          ...winOpt,
          id: formattedPoll.winOption?.id,
        };
      }
    }
    formattedPoll.winOption = winOption;
  }

  return formattedPoll;
};

export const DEFAULT_IDEA_DETAIL_FIELDS = [
  'id',
  'title',
  'description',
  'companyID',
  'createdAt',
  'image { key bucket region }',
  'video',
  'hashtag',
  'category',
  'startTime',
  'endTime',
  'owner',
  'themeID',
  {
    pledges: [
      {items:['id','title', 'description','price','video','currency']}
    ],
  },
  {
    comments:[{
      items:['id','userID','name','ideaID','content','createdAt']
    }]
  },
  {
    scores: [
      {items:['level_of_success','investment_required','talent_required','consultation_required','connection_required']}
    ],
  }
  
];

export const DEFAULT_POLL_DETAIL_FIELDS = [
  'id',
  'title',
  'question',
  'description',
  'category',
  'hashtag',
  'owner',
  'maxVote',
  'isNotExact',
  'companyID',
  'grc',
  'division',
  {
    company: ['name'],
  },
  'createdAt',
  'image { key bucket region }',
  'video',
  'status',
  'hasPledge',
  'startTime',
  'endTime',
  'pledgePeriod1StartTime',
  'pledgePeriod1EndTime',
  'pledgePeriod2StartTime',
  'pledgePeriod2EndTime',
  'hasPledge',
  'isGroup',
  'private',
  'password',
  'status',
  'themeID',
  {
    comments:[{
      items:['id','userID','name','pollID','content','createdAt']
    }]
  },
  {
    options: [
      'id',
      'title',
      'description',
      { detail: ['image { key bucket region }', 'video', 'price'] },
    ],
  },
  {
    winOption: [
      'id',
      'title',
      'description',
      { detail: ['image { key bucket region }', 'video', 'price'] },
    ],
  },
  { voteResults: [{ items: ['id', 'count'] }] },
];

const getPollById = async (
  pollId: string,
  fields: any[],
  options?: {
    publicMode?: boolean;
  }
): Promise<PollDetail> => {
  const res: any = await getPollDetail(fields, pollId, options?.publicMode);
  console.log('res', res);
  const data: PollDetail = {
    poll: res.data?.result,
  };
  if (res.data?.subPolls?.data?.result?.items)
    data.subPolls = res.data?.subPolls?.data?.result?.items;

  if (!data.poll || data.poll.status === PollStatus.CLOSED) {
    const error: ApiException = new Error('Poll is no longer available.');
    error.code = 'NotFound';
    error.info = res;
    throw error;
  }

  return data;
};
export const fetchIdea = async (

  id:string
): Promise<any> => {

  const ideaDetail = await getIdeaById(
    DEFAULT_IDEA_DETAIL_FIELDS,
    id
  );
  if (!ideaDetail.data.result) {
   return  'NotFound'
  }
  else{
    const data=await formatIdeaData(ideaDetail.data.result)
    console.log('clgttt',data)
  return data
  }

};
export const fetchPollDetails = async (
  _query: string,
  pollId: string,
  options?: {
    publicMode?: boolean;
  }
): Promise<FormattedPollDetail> => {
  const pollDetail = await getPollById(
    pollId,
    DEFAULT_POLL_DETAIL_FIELDS,
    options
  );

  const subPollsPromises = await Promise.all(
    pollDetail.subPolls
      ? pollDetail.subPolls.map((poll) => formatPollData(poll))
      : []
  );

  const [poll, subPolls] = await Promise.all([
    formatPollData(pollDetail.poll),
    subPollsPromises,
  ]);

  return { poll, subPolls };
};


export interface VoteItem {
  option: { id: string };
  subPollID: string;
}

export const getPollVoted = async (
  _query: string,
  pollId: string,
  userId: string
): Promise<VoteItem[]> => {
  const res: any = await getVotedPollInfo(
    [{ items: [{ option: ['id'] }, 'subPollID'] }],
    userId,
    pollId
  );

  const votedItems = res.data?.result?.items;

  return votedItems;
};

export const getPollPledged = async (
  _query: string,
  pollId: string,
  userId: string
): Promise<boolean> => {
  return checkPledgedUserByPoll(userId, pollId);
};

export interface PollVoter {
  id: string;
  option: {
    description?: string;
    detail?: string;
    id: string;
    title?: string;
  };
  user: {
    email: string;
    username: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    phone?: string;
    yearOfBirth?: string;
  };
  userID: string;
}

export const getPollVoters = async (
  _query: string,
  pollId: string
): Promise<GraphQLResult<{ result: { items: PollVoter[] } }>> => {
  return listVotedUser(pollId) as any;
};

export const getUserPledges = async (
  _query: string,
  userId: string,
  fields: undefined | any[] = DEFAULT_POLL_DETAIL_FIELDS
): Promise<FormattedPoll[]> => {
  const polls: any = await listPledgedPollsByUser(userId, fields);
  return await Promise.all(
    polls.data.result?.items.map((poll) => formatPollData(poll))
  );
};

export const getPledges = async (
  _query: string,
  pollId: string,
  fields: undefined | any[] = DEFAULT_USER_FIELDS
): Promise<{ user: User }[]> => {
  const res: any = await listPledgedUsersByPoll(pollId, fields);
  return res.data?.result?.items;
};

export const getPledgesFeed = async (
  _query: string,
  userId: string,
  fields: undefined | any[] = [
    'id',
    'title',
    'status',
    'owner',
    'startTime',
    'endTime',
    'pledgePeriod1StartTime',
    'pledgePeriod1EndTime',
    'image { key bucket region }',
    {
      options: ['id', 'description'],
    },
    { voteResults: [{ items: ['count'] }] },
  ]
): Promise<FormattedPoll[]> => {
  const polls: any = await listPledgedPollsByUser(userId, fields);
  return await Promise.all(
    polls.data.result?.items.map((pledgePoll) =>
      formatPollData(pledgePoll.poll)
    )
  );
};
